import { authRoles } from 'app/auth';
import MailConfirm from './MailConfirm';

const MailConfirmConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false,
                },
                toolbar: {
                    display: false,
                },
                footer: {
                    display: false,
                },
                leftSidePanel: {
                    display: false,
                },
                rightSidePanel: {
                    display: false,
                },
            },
        },
    },
    auth: authRoles.onlyGuest,
    routes: [
        {
            path: '/mail_confirm',
            component: MailConfirm,
        },
    ],
};

export default MailConfirmConfig;
